var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShortlist = function SvgShortlist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FFF",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    d: "M6.66377804,12.0103667 C6.85467399,12.1862449 7.14840775,12.1868013 7.33996863,12.0116476 L7.52037698,11.846694 C10.4133674,9.18600047 11.3179531,8.24297499 11.9494023,7.05369364 C12.2679269,6.45377943 12.4230769,5.8833705 12.4230769,5.29700272 C12.4230769,3.72548999 11.2121985,2.5 9.66538462,2.5 C8.79968324,2.5 7.94470884,2.90670095 7.38258677,3.57477308 L7,4.02947068 L6.61741323,3.57477308 C6.05529116,2.90670095 5.20031676,2.5 4.33461538,2.5 C2.78780146,2.5 1.57692308,3.72548999 1.57692308,5.29700272 C1.57692308,5.88588466 1.73340796,6.4586853 2.05471743,7.06126617 C2.68799666,8.24891226 3.59889285,9.19694245 6.47994688,11.8409976 L6.66377804,12.0103667 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShortlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shortlist.2c69ccd0.svg";
export { ForwardRef as ReactComponent };